/* React */
import React from "react";

/* Ionic */
import { menuController } from "@ionic/core/components";

/* Constants */
import { ADMIN_DASHBOARD_NAV_ITEMS } from "src/shared/constants/menu/NavItems";
import { MenuType } from "src/shared/constants/menu/Menu";

/* Components */
import NavItem from "src/components/shared/nav-item/NavItem";

const AdminDashboardMenu: React.FC = () => {
  const navItems = ADMIN_DASHBOARD_NAV_ITEMS;

  const handleAdminDashboardMenu = () => {
    menuController.close(MenuType.ADMIN_DASHBOARD);
  };

  return (
    <>
      {navItems.map((item, index) => {
        return (
          <NavItem
            key={index}
            item={item}
            showName={true}
            onClick={handleAdminDashboardMenu}
            scssProps={{
              paddingStart: "32px",
              activeColor: "var(--ion-gradient-secondary)",
            }}
          />
        );
      })}
    </>
  );
};

export default AdminDashboardMenu;
